import { render, staticRenderFns } from "./PageRegionAdd.vue?vue&type=template&id=47adbbee&scoped=true"
import script from "./PageRegionAdd.vue?vue&type=script&lang=js"
export * from "./PageRegionAdd.vue?vue&type=script&lang=js"
import style0 from "./PageRegionAdd.vue?vue&type=style&index=0&id=47adbbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47adbbee",
  null
  
)

export default component.exports